import script from "./console.vue?vue&type=script&setup=true&lang=ts"
export * from "./console.vue?vue&type=script&setup=true&lang=ts"

import "./console.vue?vue&type=style&index=0&id=5fd0e1fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd0e1fb"]])

export default __exports__